var render = function render(){var _vm=this,_c=_vm._self._c;return _c('STextArea',{key:_vm.namespace,attrs:{"name":_vm.fieldName,"input-data":_vm.paragraphText,"namespace":_vm.namespace}})
}
var staticRenderFns = []

export { render, staticRenderFns }